/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type resetPassword_viewer = {
    readonly id: string;
    readonly actualPersonId: string | null;
    readonly lastName: string | null;
    readonly " $refType": "resetPassword_viewer";
};
export type resetPassword_viewer$data = resetPassword_viewer;
export type resetPassword_viewer$key = {
    readonly " $data"?: resetPassword_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"resetPassword_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "resetPassword_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = 'ad4457293fa6ac134ece3729231f7fcf';
export default node;
